import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MDContainer from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import Divider from "@mui/material/Divider";
import { Link as RouterLink } from "react-router-dom";
import { Route } from "react-router";
import MyPictureSetsPage from "../MyPictureSets/MyPictureSets";
import MyPictureSetPage from "../MyPictureSet/MyPictureSet";
import AddPictureSetPage from "../AddPictureSet/AddPictureSet";
import MyOrdersPage from "../MyOrders/MyOrders";

import PersonIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/ManageAccounts";
import ContactInfoIcon from "@mui/icons-material/PinDrop";
import MyPictureSetsIcon from "@mui/icons-material/Photo";
import OrderHistoryIcon from "@mui/icons-material/History";
import BlockIcon from "@mui/icons-material/Block";
import CommunicationIcon from "@mui/icons-material/Chat";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import ListItemIcon from "@mui/material/ListItemIcon";
import MyContactInfoPage from "../MyContactInfo/MyContactInfo";
import ChangePasswordPage from "../ChangePassword/ChangePassword";
import MyCommunicationSettingsPage from "../MyCommunicationSettings/MyCommunicationSettings";
import AppBar from "../../Components/AppBar";
import CancelPicturePackagesPage from "../MyPictureSet/CancelPicturePackagesPage";
import { useAPI } from "../../../../lib/common";
import MyAccountYearbookPose from "@/react/Webshop/Mobile/Pages/MyAccountYearbookPose/MyAccountYearbookPose";
import MyAccountFavoritePictures from "@/react/Webshop/Mobile/Pages/MyAccountFavoritePictures/MyAccountFavoritePictures";
import DownloadMyDataPage from "@/react/Webshop/Mobile/Pages/DownloadMyDataPage/DownloadMyDataPage";
import DeleteAccountPage from "@/react/Webshop/Mobile/Pages/DeleteAccountPage/DeleteAccountPage";
import ChangeUsernamePage from "@/react/Webshop/Mobile/Pages/ChangeUsernamePage/ChangeUsernamePage";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

function ListItemLink(props) {
  const { icon, primary, to } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to],
  );

  return (
    <li>
      <ListItemButton component={renderLink}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItemButton>
    </li>
  );
}

export default () => {
  return (
    <>
      <Route exact path={"/my-account"} component={MyAccountPage} />
      <Route
        exact
        path={"/my-account/contact-info"}
        component={MyContactInfoPage}
      />
      <Route
        exact
        path={"/my-account/communication"}
        component={MyCommunicationSettingsPage}
      />
      <Route
        exact
        path={"/my-account/change-password"}
        component={ChangePasswordPage}
      />
      <Route
        exact
        path={"/my-account/change-username"}
        component={ChangeUsernamePage}
      />
      <Route
        exact
        path={"/my-account/orders/:orderUuid?"}
        component={MyOrdersPage}
      />
      <Route
        exact
        path={"/my-account/add-picture-set"}
        component={AddPictureSetPage}
      />
      <Route
        exact
        path={"/my-account/picture-sets"}
        component={MyPictureSetsPage}
      />
      <Route
        exact
        path={"/my-account/picture-sets/:pictureSetUuid/yearbook-pose"}
        component={MyAccountYearbookPose}
      />
      <Route
        exact
        path={
          "/my-account/picture-sets/:pictureSetUuid/yearbook-pose/:jobPoseUuid"
        }
        component={MyAccountYearbookPose}
      />
      <Route
        exact
        path={"/my-account/picture-sets/:pictureSetUuid/favorites"}
        component={MyAccountFavoritePictures}
      />
      <Route
        exact
        path={"/my-account/picture-sets/:pictureSetUuid"}
        component={MyPictureSetPage}
      />
      <Route
        exact
        path={"/my-account/cancel-picture-packages"}
        component={CancelPicturePackagesPage}
      />
      <Route exact path={"/my-account/delete"} component={DeleteAccountPage} />
      <Route
        exact
        path={"/my-account/download-data"}
        component={DownloadMyDataPage}
      />
    </>
  );
};

const MyAccountPage = () => {
  const { t } = useTranslation();
  const [data, loading] = useAPI(
    "/sections/my-account/ajax/get_account_data.php",
  );

  if (loading) {
    return (
      <div>
        <Trans>Fetching account settings</Trans>
      </div>
    );
  }

  const { packageForInspectionSubjects } = data;

  const items = [
    {
      title: t("Update contact information"),
      icon: <ContactInfoIcon />,
      link: "/my-account/contact-info",
    },
    {
      title: t("Change password"),
      icon: <PersonIcon />,
      link: "/my-account/change-password",
    },
    {
      title: t("Change user name"),
      icon: <EmailIcon />,
      link: "/my-account/change-username",
    },
    {
      title: t("My picture sets"),
      icon: <MyPictureSetsIcon />,
      link: "/my-account/picture-sets",
    },
    {
      title: t("Order history"),
      icon: <OrderHistoryIcon />,
      link: "/my-account/orders",
    },
  ];
  if (packageForInspectionSubjects.length > 0) {
    items.push({
      title: t("Cancel picture packages"),
      icon: <BlockIcon />,
      link: "/my-account/cancel-picture-packages",
    });
  }

  items.push({
    title: t("Communication"),
    icon: <CommunicationIcon />,
    link: "/my-account/communication",
  });

  items.push({
    title: t("Download my data"),
    icon: <DownloadIcon />,
    link: "/my-account/download-data",
  });

  items.push({
    title: t("Delete my account"),
    icon: <DeleteIcon />,
    link: "/my-account/delete",
  });

  return (
    <MobilePage>
      <AppBar />

      <PageHeader>
        <Trans>My account</Trans>
      </PageHeader>

      <Container>
        <MDContainer>
          <Paper>
            <List>
              {items.map((item, index) => {
                return (
                  <>
                    <ListItemLink
                      to={item.link}
                      primary={item.title}
                      icon={item.icon}
                    />
                    {index < items.length - 1 && <Divider />}
                  </>
                );
              })}
            </List>
          </Paper>
        </MDContainer>
      </Container>
    </MobilePage>
  );
};
